import { DeleteAvatarRequestSchema, DeleteAvatarResponseSchema } from './delete-avatar.schema';
/**
 * Delete Avatar Endpoint Contract
 * Removes user's avatar
 */ export const deleteAvatarContract = {
    method: 'DELETE',
    path: '/api/v2/avatar',
    description: 'Delete user avatar',
    requestSchema: DeleteAvatarRequestSchema,
    responseSchema: DeleteAvatarResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - invalid or missing token',
            404: 'User not found',
            500: 'Internal server error'
        }
    }
};

//# sourceMappingURL=delete-avatar.contract.js.map